"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { FolderOpen } from "lucide-react";

export default function BusinessSectionBlock({
  title,
  description,
  image,
  href,
  reverse = false,
}) {
  return (
    <section className="bg-zinc-50 py-12 sm:py-16">
      <div
        className={[
          "max-w-6xl mx-auto px-4 lg:px-0 grid md:grid-cols-2 gap-8 items-stretch",
          reverse ? "md:[&>*:first-child]:order-2 md:[&>*:last-child]:order-1" : "",
        ].join(" ")}
      >
        {/* Text */}
        <div className="bg-white rounded-2xl shadow-sm p-8 flex flex-col justify-center">
          <h3 className="text-lg sm:text-xl font-semibold text-[#003B5C]">
            {title}
          </h3>

          <p className="mt-2 text-sm sm:text-base text-zinc-600 leading-relaxed">
            {description}
          </p>

          {href ? (
            <div className="mt-3 text-xs sm:text-sm">
              <Link
                href={href}
                className="flex items-center gap-3 text-zinc-600 hover:text-zinc-800 transition-colors"
              >
                <div className="w-8 h-8 rounded-full border border-zinc-300 flex items-center justify-center">
                  <FolderOpen className="w-4 h-4 text-zinc-500" />
                </div>
                <span>Click on each image or open the full directory.</span>
              </Link>
            </div>
          ) : null}
        </div>

        {/* Image */}
        <div className="rounded-2xl overflow-hidden shadow-sm relative min-h-[260px] sm:min-h-[320px]">
          <Image
            src={image}
            alt={title}
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            className="object-cover"
            priority={false}
          />
        </div>
      </div>
    </section>
  );
}